import React from 'react'
import styled from 'styled-components'
import media from '../../utils/media'
import Text, { useTranslations } from '../../utils/Text'

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const Label = styled.label`
  position: relative;
  background-color: ${props =>
    props.checked ? '#414141' : '#f9f9f9'};
  transition: background-color 0.2s ease-in;
  height: 77px;
  width: 335px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px !important;
  ${media.tablet`
    width: 315px;
  `}
  ${media.mobileL`
    width: 100%;
  `}
`

const ColorBox = styled.div`
  display: inline-flex !important;
  height: 77px;
  width: 72px;
  background-color: ${props => props.color};
`

const Answer = styled.div`
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 20px;
`

const Title = styled.div`
  span {
    color: ${props => (props.checked ? '#ffffff' : '#414141')};
    transition: color 0.2s ease-in;
    font-size: 16px;
    font-weight: bold;
  }
`

const Subtitle = styled.div`
  span {
    color: ${props => (props.checked ? '#ffffff' : '#414141')};
    transition: color 0.2s ease-in;
    font-size: ${props =>
      props.subtitleSize ? props.subtitleSize : '15'}px;
    font-weight: normal;
  }
`

export default function RadioImage({
  title,
  subtitle,
  subtitleSize,
  color,
  value,
  checked,
  onChange,
}) {
  const size = useTranslations(subtitleSize, {})
  return (
    <Label checked={checked}>
      <HiddenRadio
        checked={checked}
        onChange={onChange}
        value={value}
      />
      <ColorBox color={color} />
      <Answer>
        <Title checked={checked}>
          <Text id={title} />
        </Title>
        <Subtitle
          checked={checked}
          subtitleSize={size}
          className="radio-answer-subtitle"
        >
          <Text id={subtitle} />
        </Subtitle>
      </Answer>
    </Label>
  )
}
